import { onValue, ref, remove, update } from 'firebase/database';
import { useState, useEffect, useRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router';

import {
  subjectsObj,
  deleteFilesStudentHomeworks,
  setStudentHomeworkTeacherChacked,
  getHomeworkContentStudent,
  getStudentsGroupView,
} from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import { PopupHomework } from '../../Components/PopupHomework/PopupHomework';
import { throwErrorRollbar } from '../../index';
import { setClassroomName } from '../../redux/slices/nameClassroomSlice';

import '../ClassRoomList/style.scss';

const arrItems = ['homeworks', 'materials', 'passedExams', 'exums'];

const ClassRoomGroup = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [homeworksContent, setHomeworksContent] = useState({});
  const [classroomList, setClassroomList] = useState([]);
  const [classroomObj, setClassroomObj] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [popupRemove, setPopupRemove] = useState(false);
  const [popupRemoveName, setPopupRemoveName] = useState('');
  const [ativeItem, setAtiveItem] = useState(0);
  const [openModalAnswer, setOpenModalAnswer] = useState(false);
  const [modalAnswer, setModalAnswer] = useState('');
  const [openPopupHomework, setOpenPopupHomework] = useState(false);
  const [popupHomeworkObj, setPopupHomeworkObj] = useState({});

  function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const prevClassroomList = usePrevious(classroomList);

  const setResponsItems = resp => {
    switch (ativeItem) {
      case 0:
        let setHomework = Object.values(resp.homeworks ? resp.homeworks : {});
        let filterHomework = setHomework.filter(item => item.subject === params.name);
        setClassroomList(filterHomework);
        break;
      case 1:
        let setMaterial = Object.values(resp.materials ? resp.materials : {});
        let filterMaterial = setMaterial.filter(
          item => subjectsObj[item.subject] === params.name && !('chapter' in item),
        );
        setClassroomList(filterMaterial);
        break;
      case 2:
        let setMaterialSecond = Object.values(resp.materials || {});
        let filterMaterialSecond = setMaterialSecond.filter(item => {
          if (Array.isArray(item.chapter)) {
            return item.chapter.every(chapterItem => {
              if (Array.isArray(chapterItem.points)) {
                return chapterItem.points.every(pointItem => pointItem.itemComplited === true);
              }
              return false;
            });
          }
          return false;
        });
        setClassroomList(filterMaterialSecond);
        break;
      case 3:
        let setMaterialThree = Object.values(resp.materials ? resp.materials : {});
        let filterMaterialThree = setMaterialThree.filter(
          item => subjectsObj[item.subject] === params.name && 'chapter' in item,
        );
        setClassroomList(filterMaterialThree);
        break;
    }
    setIsLoading(false);
  };

  useEffect(() => {
    console.log('classroomList: ', classroomList);
    const dbRef = ref(database, `StudentsGroup/${params.id}`);

    const unsubscribe = onValue(dbRef, snapshot => {
      const obj = snapshot.val();
      setClassroomObj(obj);
    });
    return () => {
      unsubscribe();
    };
  }, [params]);

  const fetchClassroomGroupList = async () => {
    await getStudentsGroupView(params.id)
      .then(response => {
        console.log('response: ', response);
        const resp = response.val();
        try {
          setClassroomObj(resp);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      })
      .catch(error => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchClassroomGroupList();
  }, []);

  const getHomeworkFunc = async params => {
    try {
      const objContentHM = await getHomeworkContentStudent(params);
      return objContentHM;
    } catch (error) {
      console.error('An error occurred while getting homework content:', error);
      error.name = 'An error occurred while getting homework content:';
      throwErrorRollbar(error);
      return {};
    }
  };

  useEffect(() => {
    async function fetchHomework() {
      const objContentHMNew = await getHomeworkFunc(params.name);
      setHomeworksContent(objContentHMNew);
    }

    fetchHomework();
  }, []);

  const ocClosePopupHomework = () => {
    setOpenPopupHomework(false);
  };

  useEffect(() => {
    if (classroomObj.homeworks || classroomObj.materials) {
      setResponsItems(classroomObj);
    }
  }, [classroomObj, ativeItem]);

  useEffect(() => {
    classroomList.forEach((item, i) => {
      if (JSON.stringify(item.teacherCheckeds) !== JSON.stringify(prevClassroomList[i]?.teacherCheckeds)) {
        // setStudentHomeworkTeacherChacked(
        //   params.id,
        //   params.name,
        //   item.id,
        //   item.teacherCheckeds,
        // );
      }
    });
  }, [classroomList, prevClassroomList]);

  const parseJson = data => {
    try {
      const parsedData = JSON.parse(data);
      return parsedData;
    } catch {
      return data;
    }
  };

  function handleTeacherCheckboxChange(event, id, keyName) {
    const isChecked = event.target.checked;

    setClassroomList(prevList => {
      return prevList.map(item => {
        if (item.id === id) {
          const teacherItem = item.teacherCheckeds ? parseJson(item.teacherCheckeds) : item.teacherCheckeds;
          return {
            ...item,
            teacherCheckeds: teacherItem.map(checkedItem => {
              if (Object.keys(checkedItem)[0] === keyName) {
                return { [keyName]: isChecked };
              } else {
                return checkedItem;
              }
            }),
          };
        } else {
          return item;
        }
      });
    });
  }

  const columns1 = [
    {
      dataField: 'name',
      text: t('homework'),
      classes: 'name-homework',
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('homework') },
    },
    {
      dataField: 'deadline',
      text: t('deadline'),
      disableClickEventBubbling: true,
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        const dateA = new Date(parseInt(a.split('.')[2]), parseInt(a.split('.')[1]) - 1, parseInt(a.split('.')[0]));

        const dateB = new Date(parseInt(b.split('.')[2]), parseInt(b.split('.')[1]) - 1, parseInt(b.split('.')[0]));

        if (order === 'asc') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      },
      attrs: { 'data-label': t('deadline') },
    },
    {
      dataField: 'completed',
      text: t('done'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('done') },
      formatter: (dataField, row) => {
        if (row.subItems) {
          const subArrayCheckeds = row.subArrayCheckeds || [];
          const subItemsCompleted = subArrayCheckeds.filter(item => item.completed);

          return (
            <div className="sub-inputs-checkboxs">
              {subArrayCheckeds.map((item, i) => (
                <div className="wrap-sub-input-checkbox">
                  <input
                    key={i}
                    type="checkbox"
                    checked={item}
                    id={String(dataField)}
                    className="checkbox check-homework"
                    readOnly
                  />
                  <span className="name-sub-input-checkbox" name={row.titles[i]} data-item="true">
                    {row.titles[i]}
                  </span>
                </div>
              ))}
            </div>
          );
        } else {
          return (
            <div>
              <input
                id={String(dataField)}
                type="checkbox"
                checked={dataField}
                className="checkbox check-homework"
                readOnly
              />
              <span className="name-sub-input-checkbox" name={row.name} data-item="false">
                {row.name}
              </span>
            </div>
          );
        }
      },
    },
    {
      dataField: 'teacherCheckeds',
      text: t('checked'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('checked') },
      formatter: (dataField, row) => {
        const teacherItem = row.teacherCheckeds ? parseJson(row.teacherCheckeds) : row.teacherCheckeds;
        if (teacherItem) {
          return (
            <div className="sub-teacher-inputs-checkboxs">
              {teacherItem.map((item, i) => {
                const keyName = Object.keys(item)[0];
                return (
                  <div className="teacher-checked-input-checkbox" key={keyName + i}>
                    <label htmlFor={item[keyName]}>
                      <input
                        type="checkbox"
                        onChange={event => handleTeacherCheckboxChange(event, row.id, keyName)}
                        id={item[keyName]}
                        checked={item[keyName]}
                        className="checkbox"
                      />
                      <span className="teacher-checked-checkbox">{t(keyName)}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          );
        }
      },
    },

    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: (dataField, row) => (
        <div className="btn-wrap">
          {row.hasOwnProperty('studentPhotos') && Object.values(row.studentPhotos).length > 0 ? (
            <button className="btn btn-primary btn-small open-modal-studet-photos">{t('look')}</button>
          ) : null}
          <button id={String(dataField)} className="btn btn-icon delete-homework">
            <span className="icon icon-delete"></span>
          </button>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      dataField: 'name',
      text: t('material'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('material') },
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('class') },
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('subject') },
    },
    {
      dataField: 'theme',
      text: t('theme'),
      flex: 1,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('theme') },
    },
    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: dataField => (
        <div className="btn-wrap">
          <button id={String(dataField)} className="btn btn-icon materials">
            <span className="icon icon-delete"></span>
          </button>
        </div>
      ),
    },
  ];

  const columns3 = [
    {
      dataField: 'name',
      text: t('exam'),
      headerStyle: {
        // width: '100%',
      },
      disableClickEventBubbling: true,
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
    },
    // {
    //   dataField: 'theme',
    //   text: t('theme'),
    //   flex: 1,
    //   disableClickEventBubbling: true,
    // },
  ];

  const columns4 = [
    {
      dataField: 'name',
      text: t('nameCourse'),
      headerStyle: {
        // width: '100%',
      },
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('nameCourse') },
    },
    {
      dataField: 'purpose',
      text: t('purpose'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('purpose') },
    },
    {
      dataField: 'deadline',
      text: t('deadline'),
      disableClickEventBubbling: true,
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        const dateA = new Date(parseInt(a.split('.')[2]), parseInt(a.split('.')[1]) - 1, parseInt(a.split('.')[0]));

        const dateB = new Date(parseInt(b.split('.')[2]), parseInt(b.split('.')[1]) - 1, parseInt(b.split('.')[0]));

        if (order === 'asc') {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      },
      attrs: { 'data-label': t('deadline') },
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('class') },
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('subject') },
    },
    {
      dataField: 'id',
      text: t('actions'),
      attrs: { 'data-label': t('actions') },
      formatter: dataField => (
        <div className="btn-wrap">
          <button id={String(dataField)} className="btn btn-primary btn-small go-to-exem">
            {t('transition-in')}
          </button>

          <button id={String(dataField)} className="btn btn-icon delete-exem">
            <span className="icon icon-delete"></span>
          </button>
        </div>
      ),
    },
  ];

  const pageSize = 10;

  const pagination = paginationFactory({
    sizePerPage: pageSize,
    hideSizePerPage: true,
  });

  const rowEvents = {
    onClick: async (e, row) => {
      if (e.target.className === 'name-homework') {
        const objInfoUserHM = {
          user: params.id,
          item: row.name,
          name: row.name,
        };
        dispatch(setClassroomName(objInfoUserHM));
        navigate(`/student-homework-list/${row.subject}/${params.id}`);
      }

      if (e.target.tagName !== 'BUTTON' && ativeItem === 1) {
        navigate('/materialView', { state: row });
      }

      /*if (e.target.tagName !== 'BUTTON' && ativeItem === 2) {
        navigate('/examView', { state: row, search: location.state });
      }*/

      if (e.target.className === 'btn btn-primary btn-small go-to-exem' && (ativeItem === 2 || ativeItem === 3)) {
        navigate(`/checklist-view/${row.id}`, {
          state: { ...row, studentId: params.id },
        });
      }

      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          const subjectName = row.name;
          await update(ref(database, `StudentsGroup/${params.id}/subjects/${subjectName}`), {
            activeSub: !row.activeSub,
            name: row.name,
          });
          setSubjectList();
          setAddSubject(prev => !prev);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }
      if (e.target.className === 'btn btn-icon delete-homework') {
        try {
          const homeworkName = row.name;
          localStorage.setItem('rowName', homeworkName);
          setModalAnswer(row);
          setPopupRemoveName('want to delete homework for group');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'name-sub-input-checkbox') {
        const homeworkId = row.id;
        const nameItem = e.target.getAttribute('name');

        setPopupHomeworkObj({});
        setOpenPopupHomework(false);
        setTimeout(() => {
          setPopupHomeworkObj({
            deadline: row.deadline,
            homeworkName: row.name,
            titels: row.titles,
            targetSubItem: nameItem,
            targetItem: {
              ops: JSON.parse(homeworksContent[homeworkId].content),
              id: row.id,
            },
          });
          setOpenPopupHomework(true);
        }, 10);
      }

      if (e.target.className === 'btn btn-icon materials') {
        try {
          const materialsId = row.id;
          localStorage.setItem('rowName', materialsId);
          setPopupRemoveName('want to delete subject for group');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-icon delete-exem') {
        try {
          const materialsId = row.id;
          localStorage.setItem('rowName', materialsId);
          setPopupRemoveName('want to delete exam for group');
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          error.name = 'Error fetching contact ' + error.name;
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-primary btn-small open-modal-studet-photos') {
        setOpenModalAnswer(true);
        setModalAnswer(row);
      }
    },
  };

  const removeHomework = async () => {
    const removeItem = localStorage.getItem('rowName');
    switch (ativeItem) {
      case 0:
        await remove(ref(database, `StudentsGroup/${params.id}/homeworks/${modalAnswer.id}`), {
          removeItem,
        });
        deleteFilesStudentHomeworks(params.id, modalAnswer.id);
        break;
      case 1:
        await remove(ref(database, `StudentsGroup/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
      case 2:
        await remove(ref(database, `StudentsGroup/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
      case 3:
        await remove(ref(database, `StudentsGroup/${params.id}/materials/${removeItem}`), {
          removeItem,
        });
        break;
    }

    localStorage.removeItem('rowName');
    setPopupRemove(false);
  };

  const notRemoveHomework = () => {
    localStorage.removeItem('rowName');
    setPopupRemove(false);
  };

  const onClickActiveItem = (e, i) => {
    e.preventDefault();
    setAtiveItem(i);
  };

  const FileRenderer = ({ url }) => {
    const [fileType, setFileType] = React.useState(null);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
      async function fetchAndSetFileType() {
        try {
          const type = await fetchFileContent(url);
          setFileType(type);
        } catch (err) {
          setError(err.message);
        }
      }

      fetchAndSetFileType();
    }, [url]);

    if (error) return <div>Error: {error}</div>;

    if (!fileType) return <div>Loading...</div>;

    if (fileType === 'image') {
      return <img src={url} alt="File" />;
    }

    if (fileType === 'word') {
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`}
          style={{ width: '90%', height: '500px', border: 'none' }}
        ></iframe>
      );
    }

    return <div>Unsupported file type</div>;
  };

  const fetchFileContent = async url => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const type = blob.type;

      if (type.startsWith('image/')) {
        return 'image';
      } else if (
        type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        type === 'application/msword'
      ) {
        return 'word';
      } else {
        return 'unknown';
      }
    } catch (error) {
      console.log('There was a problem with the fetch operation:', error.message);
      error.name = 'There was a problem with the fetch operation:';
      throwErrorRollbar(error);
    }
  };

  return (
    classroomList && (
      <>
        <div className="title-wrap">
          <h1>{`${t(params.name)}, ${classroomObj.groupName}`}</h1>
        </div>
        <div className="materials-page classroom-list-page container">
          <div className="classroom-list-row-top">
            <ul className="classroom-list-navigate">
              {arrItems.map((item, i) => (
                <li key={i}>
                  <a href="#" className={i === ativeItem ? 'active' : ''} onClick={e => onClickActiveItem(e, i)}>
                    {t(item)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <hr />
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {ativeItem === 0 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider key={i18n.language} keyField="content" data={classroomList} columns={columns1}>
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                          defaultSorted={[{ dataField: 'deadline', order: 'asc' }]}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noHomeworks'} />
                ))}
              {ativeItem === 1 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider key={i18n.language} keyField="content" data={classroomList} columns={columns2}>
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noMaterials'} />
                ))}
              {ativeItem === 2 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider key={i18n.language} keyField="content" data={classroomList} columns={columns4}>
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noExam'} />
                ))}

              {ativeItem === 3 &&
                (classroomList.length > 0 ? (
                  <ToolkitProvider key={i18n.language} keyField="content" data={classroomList} columns={columns4}>
                    {props => (
                      <div className="materials-table">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={classroomList.length > pageSize ? pagination : null}
                          rowEvents={rowEvents}
                          defaultSorted={[
                            { dataField: 'deadline', order: 'asc' },
                            { dataField: 'time', order: 'asc' },
                          ]}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                ) : (
                  <NoItems titleNoItems={'noMaterials'} />
                ))}
            </>
          )}
          <div className={popupRemove ? 'popup-remove active' : 'popup-remove'}>
            <div className="popup-remove-content">
              <h3>{t(popupRemoveName)}</h3>

              <div className="btn-wrap">
                <button className="btn btn-primary more btn-active" onClick={() => removeHomework()}>
                  {t('yes')}
                </button>

                <button className="btn more btn-view" onClick={notRemoveHomework}>
                  {t('no')}
                </button>
              </div>
            </div>
          </div>

          {openPopupHomework && popupHomeworkObj && (
            <PopupHomework homeworkObj={popupHomeworkObj} closeHomework={setOpenPopupHomework} />
          )}

          {openModalAnswer && (
            <div className={openModalAnswer ? 'popup-answer-student active' : 'popup-answer-student'}>
              <div className="popup-answer-student-content">
                <button className="btn btn-icon" onClick={() => setOpenModalAnswer(false)}>
                  <span className="icon icon-plus"></span>
                </button>

                <h2>{t('Student Answers')}</h2>

                <div className="img-block">
                  {modalAnswer &&
                    Object.values(modalAnswer.studentPhotos)
                      .filter(elem => elem)
                      .map((item, i) => {
                        const hasNestedArray = Array.isArray(item[0]);

                        if (hasNestedArray) {
                          return Object.values(item).map((itemElem, ElemIndex) => {
                            return (
                              <div key={ElemIndex} className="wrap-content-images">
                                <h3>{modalAnswer.titles[ElemIndex]}</h3>

                                <div className="col-images">
                                  {itemElem.map((itemImg, indexImg) => {
                                    return (
                                      <div className="wrap-img" key={ElemIndex + indexImg}>
                                        <FileRenderer url={itemImg} />
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          });
                        } else {
                          return (
                            <div key={i} className="wrap-content-images">
                              <h3>{modalAnswer.name}</h3>

                              <div className="col-images">
                                {Object.values(item).map((itemImg, indexImg) => {
                                  return (
                                    <div className="wrap-img" key={i + indexImg}>
                                      <FileRenderer url={itemImg} />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }
                      })}
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    )
  );
};

export default ClassRoomGroup;
